import $api from '../services';

export default {
    unsubsribeFromEmails(id) {
        return $api.put(`/unsubscribe/${id}`);
    }
};
